import React from 'react'
import { Route, BrowserRouter as Router, Routes, Link  } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import { useEffect, useRef, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import config from '../Config';
import { Modal, Button } from 'react-bootstrap';

export const Banner = () => {
      const [modalShow, setModalShow] = React.useState(false);
      const [lgShow, setLgShow] = useState(false);
  
      const [showModal, setShowModal] = useState(false);
      const [modalContent, setModalContent] = useState('');
      const [loading, setLoading] = useState(false);
      const dataUrl = 'https://calendly.com/chris-tcb/portal?month=2025-08'; // Replace with your URL
      

      const handleShow = () => setShowModal(true);
      const handleClose = () => setShowModal(false);



useEffect(() => {
        if (showModal && !modalContent && !loading) {
          setLoading(true);
          fetch(dataUrl)
            .then(response => response.text()) // Or response.json() if it's JSON
            .then(data => {
              setModalContent(data);
              setLoading(false);
            })
            .catch(error => {
              console.error('Error fetching data:', error);
              setModalContent('Error loading content.');
              setLoading(false);
            });
        }
      }, [showModal, modalContent, loading, dataUrl]);

  return (
    <>
    <section className='banner-bg bg-transparentcustm'>
      <img className='banr-nwdots' src={`${config.siteBaseUrl}/assets/imgs/our-integrations-bannerbg.svg`} alt='' />
      
        <Container>
           <Row>
            <Col xs lg="12" className='text-left'>
            <span><img src='assets/imgs/h-icon.svg' alt='' />HIGH RISK BUSINESSES</span>
            <h1>Tailored solutions for every challenge</h1>
            </Col>
            <Col xs lg="7" className='text-left'>
            <p>TCB Pay specializes in providing tailored merchant accounts for high-risk clients in various industries. We understand that being labeled as high-risk can be a burden, and we offer customized solutions to fit your business needs.</p>
            {/* <Link className="get-btn2 mt-10" to="https://calendly.com/chris-tcb/high-risk" target='blank'>Get Started</Link> */}
            <a className="get-btn2 mt-10" onClick={() => setLgShow(true)}>Get Started</a>
            {/* <a className="get-btn2 mt-10">Get Started</a> */}
            <Link className="contact-btn1 mt-10" to={`${config.siteBaseUrl}/contact`}>Contact Us</Link>
            </Col>
          </Row>  
        </Container>

        <Modal className='potal-mdlbx' centered 
        size="xl"
        show={lgShow}
        onHide={() => setLgShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-modal-sizes-title-xl">
        <Modal.Header closeButton>
            <div className='container1'>
                <iframe src="https://calendly.com/chris-tcb/high-risk?embed_domain=dev.tcbpay.com&embed_type=Inline&primary_color=397ab7&month=2025-09" width="100%" height="680" frameBorder="0" title="Select a Date &amp; Time - Calendly"></iframe>
            </div> 
        </Modal.Header> 
      </Modal>
    </section>
    </>
  )
}
